import React from "react";
import styled from "styled-components";

import { StaticAssets } from "../styles/custom-assets";
import { theme } from "../styles/theme";

/** Full-bleed brand screen shown while the app boots, before anything else can be rendered. */
export function BootSplash() {
  return (
    <Screen>
      <SplashLogo src={StaticAssets.brandLogo} alt="" />
    </Screen>
  );
}

const Screen = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  width: 100%;
  min-height: 100vh;
  background: ${theme.brandGradient};
`;

const SplashLogo = styled.img`
  width: 280px;
  max-width: 60%;
  object-fit: contain;
`;
